export const SORT_BY_PARAM = 'sortBy';
export const CURRENT_PAGE_PARAM = 'page';
export const CATEGORY_ID_PARAM = 'categoryId';
export const FILTER_BY_EQUIPMENT_PARAM = 'filterByEquipment';
export const FILTER_BY_ATTACHMENT_PARAM = 'filterByAttachment';
export const MODEL_PARAM = 'model';
export const PRODUCT_FAMILY_NAME_PARAM = 'productFamilyName';
export const SERIAL_NUMBER_PARAM = 'serialNumber';
export const SEARCH_QUERY_PARAM = 'q';
export const FACET_PARAM = 'facet';
export const DIAGRAM_FACET_PARAM = 'd_facet';
export const PART_FACET_PARAM = 'p_facet';
export const SCROLL_TO_PRODUCT_PARAM = 'scrollToProduct';
export const IS_NER_ENABLED = 'isNerEnabled';
export const RESPONSE_FILTER_PARAM = 'responseFilter';
export const DIAGRAM_SORT_BY_PARAM = 'd_sortBy';
export const PARTS_SORT_BY_PARAM = 'p_sortBy';
